import { mailStore } from 'owa-mail-store';
import { action, select } from 'satcheljs/lib/legacy';
export default action('setIsPendingDeleteConversationItemParts')(select({
    conversationItemParts: function (conversationId) {
        return mailStore.conversations.get(conversationId);
    },
})(function setIsPendingDeleteConversationItemParts(conversationId, isPendingDelete, state) {
    var conversationItemParts = state.conversationItemParts;
    if (conversationItemParts) {
        conversationItemParts.isPendingDelete = isPendingDelete;
    }
}));
//# sourceMappingURL=setIsPendingDeleteConversationItemParts.js.map